import React, { useState, useEffect } from "react";
import "./AICreator.scss";
import { Row, Col, Button, Layout } from "antd";
import { CALENDLY_LINK } from "../../env";
import { trackCta } from "../../analytics";
import { buildRegisterUrl } from "../../utils/registerRedirect";
import BrandsCarousel from "../pricingV2/components/BrandsCarousel/BrandsCarousel";
import StatsSection from "./StatsSection";
import JoinFutureSection from "./JoinFutureSection";
import HowItWorksSection from "./HowItWorksSection";
import TestimonialsSection from "./TestimonialsSection";
import ComparisonSection from "./ComparisonSectionAICreator";
import Metrics from "../SMBLandingPage/Metrics/Metrics";
import BookendSection from "../SMBLandingPage/BookendSection/BookendSection";
import PricingSection from "./PricingSection";
const { Content } = Layout;


const HeroSection = () => {
    const images = [
        "/ai_creator/hero_slideshow/hero-img1.jpg",
        "/ai_creator/hero_slideshow/hero-img2.jpg",
        "/ai_creator/hero_slideshow/hero-img3.jpg",
        "/ai_creator/hero_slideshow/hero-img4.jpg",
        "/ai_creator/hero_slideshow/hero-img5.jpg",
        "/ai_creator/hero_slideshow/hero-img6.jpg",
    ]

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (

        <Row className="ai-background-container container-fluid ai-content-container" gutter={10} style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
            <Col span={11} style={{ display: 'flex', position: 'relative', overflow: 'hidden' }}>
                <div className="hero-image-slider">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`AI Generated Lifestyle ${index + 1}`}
                            className="lifestyle-hero-image mb-2"
                            style={{
                                position: index === 0 ? 'relative' : 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                opacity: currentImageIndex === index ? 1 : 0,
                                transition: 'opacity 1.5s ease-in-out',
                                zIndex: currentImageIndex === index ? 2 : 1
                            }}
                        />
                    ))}
                </div>
            </Col>
            <Col span={13} className="hero-content-section" style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="white-bg mb-16" style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <div className="manrope f-14 w-700 blue-gradient" style={{ display: 'flex', alignItems: 'center' }}>
                        <img src='/ai_creator/ai-creator-twinkle.svg' className="mr-1" alt="AI Creator icon" style={{ width: '16px', height: '16px' }} />
                        AI Creator by ALL3D
                    </div>
                </div>
                <h1 className="manrope" style={{
                    fontFamily: 'Manrope',
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontSize: '50px',
                    lineHeight: '60px',
                    letterSpacing: '0%',
                    marginBottom: '24px',
                    color: '#1F2937'
                }}>
                    One AI workflow for quality,<br />
                    on-brand product images <br />
                    <span className="blue-gradient">in minutes</span>
                </h1>

                <p className="manrope" style={{
                    fontSize: '16px',
                    fontWeight: 500,
                    lineHeight: '24px',
                    color: 'rgba(0, 0, 0, 0.85)',
                    maxWidth: '580px'
                }}>
                    Create high-quality visuals from the best AI image models for your product—without tool-hopping, prompt chaos, or endless revisions.
                </p>

                <div className="hero-actions">
                    <Button
                        className="manrope f-16 w-700 lh-24 blue-button action-btn"
                        onClick={() => {
                            trackCta('free_trial_click', {
                                section: 'hero',
                                placement: 'desktop',
                                button: 'get_started_for_free',
                            });

                            const email = new URLSearchParams(window.location.search).get('email');
                            let targetUrl = buildRegisterUrl("ai-asset-creator");
                            if (email) targetUrl += `&email=${encodeURIComponent(email)}`;
                            window.open(targetUrl, "_blank");
                        }}
                    >
                        Get started for free
                    </Button>
                    <Button
                        className="outline-btn action-btn"
                        onClick={() => {
                            trackCta('schedule_demo_click', {
                                section: 'hero',
                                placement: 'desktop',
                                button: 'schedule_a_demo',
                            });
                            window.open(CALENDLY_LINK, "_blank")
                        }}
                    >
                        Schedule a demo
                    </Button>
                </div>
            </Col>
        </Row>
        // </Content>
    )
}

const AICreatorWeb = () => {

    return (
        <>
            <Content className="d-none d-lg-block ">
                <HeroSection />
                <BrandsCarousel />
                <HowItWorksSection />
                <ComparisonSection />
                <PricingSection />
                <TestimonialsSection />
                <Metrics />
                <BookendSection />
            </Content>
        </>
    )
}


export default AICreatorWeb;
